export default "../fonts/akzidgrtskprobolcnd-webfont.70d1ea17097a8ab44950cc27765b20ca.ttf";